<mat-toolbar class="header app-header">
    <button type="button" class="sidebar-toggle" aria-label="Toggle sidebar" mat-icon-button (click)="onToggleSidebar()">
        <i-feather name="menu" class="text-light-muted feather-base mt-n3"></i-feather>
    </button>

    <nav class="header-breadcrumb" *ngIf="breadcrumbItems?.length">
        <ng-container *ngFor="let item of breadcrumbItems; let last = last">
            <div *ngIf="!last">
                <a class="breadcrumb-link" [routerLink]="item.link">
                    <i-feather *ngIf="item.iconBreadcrumb" name="{{ item.iconBreadcrumb }}" class="feather-base breadcrumb-icon"></i-feather>
                    <span *ngIf="!item.iconBreadcrumb">{{ item.menu }}</span>
                </a>
            </div>
            <div *ngIf="!last">
                <i-feather name="chevron-right" class="feather-base breadcrumb-sep"></i-feather>
            </div>
            <div *ngIf="last">
                <span class="breadcrumb-current">
                    <i-feather *ngIf="item.iconBreadcrumb" name="{{ item.iconBreadcrumb }}" class="feather-base breadcrumb-icon"></i-feather>
                    <span>{{ item.menu }}</span>
                </span>
            </div>
        </ng-container>
    </nav>

    <div class="header-actions">
        <!-- <div class="academic-year-control" style="width: 200px;">
            <app-select-academic-year-only (academicYearChanged)="onChangeAcademicYear($event)" [clear]="false">
            </app-select-academic-year-only>
        </div> -->

        <!-- <div class="header-divider"></div> -->

        <button mat-button class="profile-menu-trigger" [matMenuTriggerFor]="menu">
            <img src="https://files.sokrates.co.id/default_avatar.png" class="profile-avatar rounded-circle" alt="">
            <span class="profile-greeting">Hi,</span>
            <span class="profile-name">{{ currentUser?.fullname || 'User' }}</span>
            <i-feather name="chevron-down" class="feather-base profile-chevron"></i-feather>
        </button>
        <mat-menu #menu="matMenu" class="profile-dropdown">
            <div class="p-16 d-flex flex-column gap-2">
                <!-- My Account: halaman akun di SSO (profil, password, perangkat), tab baru -->
                <button mat-stroked-button class="w-100" (click)="onOpenAccount()">
                    <i-feather name="user" class="feather-sm me-4"></i-feather>
                    My Account
                    <i-feather name="external-link" class="feather-sm ms-4"></i-feather>
                </button>
                <!-- Switch Account: SSO yang menentukan (allow_switch_account: SUPERADMIN atau CHANGE_USER); login form biasa tidak bisa switch -->
                <button
                    *ngIf="canSwitchAccount"
                    mat-stroked-button
                    color="primary"
                    class="w-100"
                    [disabled]="isSwitchingAccount"
                    (click)="onSwitchAccount()">
                    <i-feather name="repeat" class="feather-sm me-4"></i-feather>
                    {{ isSwitchingAccount ? 'Memproses...' : 'Switch Account' }}
                </button>
                <!-- Back to SUPERADMIN: muncul kalau sedang di switched session -->
                <button
                    *ngIf="isSwitchedAccount"
                    mat-stroked-button
                    color="warn"
                    class="w-100"
                    [disabled]="isRestoringAccount"
                    (click)="onRestoreAccount()">
                    <i-feather name="corner-up-left" class="feather-sm me-4"></i-feather>
                    {{ isRestoringAccount ? 'Memproses...' : 'Kembali ke ' + (realAdminName || 'SUPERADMIN') }}
                    </button>
                <button mat-flat-button color="accent" class="w-100 text-white" (click)="onLogOut()">Logout</button>
            </div>
        </mat-menu>
    </div>
</mat-toolbar>
